export default __webpack_public_path__ + "static/media/search_worker.d102f98a.png";